/** A hooped barrel (lantern-water `world.js` `barrel`). Params: `size` (0.55). */
import * as THREE from 'three';
import { num } from '../kit.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'barrel',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    ctx.barrel(root, 0, 0, num(ctx, 'size', 0.55));
    return { root };
  },
};
